/**
 * Retry lazy loading with better error handling
 * Fixes ChunkLoadError issues after deployments
 */
export const lazyWithRetry = (componentImport) => {
  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(
      window.sessionStorage.getItem('retry-lazy-refreshed') || 'false'
    );

    componentImport()
      .then((component) => {
        window.sessionStorage.setItem('retry-lazy-refreshed', 'false');
        resolve(component);
      })
      .catch((error) => {
        if (!hasRefreshed) {
          // Only refresh once to avoid infinite loops
          window.sessionStorage.setItem('retry-lazy-refreshed', 'true');
          console.log('Chunk loading failed, refreshing page...');
          return window.location.reload();
        }
        // If already refreshed, reject to show error
        reject(error);
      });
  });
};
